// ! IMPORTANT NOTES
// Replica of common components
// Caution:
// 1. This is a fast fix to solve website performance
// 2. This may not adhere to our kit guidelines

// Import required libraries
import React from "react";
import { makeStyles } from "@material-ui/core";

const useStyles = makeStyles((theme) => ({
  root: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
  },
  vr: (props) => ({
    height: props?.style?.height || "16px",
    width: props?.style?.width || "1px",
    margin: props?.style?.margin || "0px 10px",
    backgroundColor: theme.palette.misc["secondaryColorLighter"],
  }),
}));

function SigviewVR(props) {
  const classes = useStyles(props);

  return (
    <div className={classes.root}>
      <div className={classes.vr}></div>
    </div>
  );
}

export default SigviewVR;
